import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface MyAccountProps {
  tabValue: number;
}
const initialState: MyAccountProps = {
  tabValue: 0,
};
const MyAccountSlice = createSlice({
  name: "myaccount",
  initialState,
  reducers: {
    setTabValue: (state, action: PayloadAction<MyAccountProps["tabValue"]>) => {
      state.tabValue = action.payload;
    },
  },
});

export const { setTabValue } = MyAccountSlice.actions;
export default MyAccountSlice;
